import React, { Component } from 'react'
import update from 'react/lib/update';
import PropTypes from 'prop-types'
import Radium from 'radium';
import Row from './table/row'
import Cell from './table/cell'
import CellSelect from './table/cellSelect'
import Header from './table/header'
import { semanticColors } from '../../../../Globals/styles';
import { measurementTypes } from '../../../../Globals/constants'

const propTypes = {}

const defaultProps = {}

class Measurements extends Component {
    constructor(props) {
        super(props)
        this.state = {
            width: [
                '5%',
                '15%',
                '10%',
                '10%',
                '10%',
                '30%',
                '10%',
                '10%',
            ]
        }
    }
    getTypeSelectPickerChildren = () => {
        let selectpickerChildren = [];
        measurementTypes.forEach((measurementType, index) => {
        if(index === 0){
            selectpickerChildren.push(
            <option
                key={index}
                value={0}>
                Intet valgt
            </option>
            )
        }
        selectpickerChildren.push(
            <option
            key={index+1}
            value={measurementType}>
            {measurementType}
            </option>
        )
        })
        return selectpickerChildren
    };
    shouldComponentUpdate(nextProps) {
        if (this.props.measurementsKey === nextProps.measurementsKey) { return false }
        return true
    }
    renderHeader = () => {
        return (
            <Row
            >
                <Header
                    content={'Pos.'}
                    style={{ width: this.state.width[0] }}
                    inputStyle={{
                        textAlign: 'center',
                    }}
                />
                <Header
                    content={'Type'}
                    style={{ width: this.state.width[1] }}
                />
                <Header
                    content={'Antal'}
                    style={{ width: this.state.width[2] }}
                    inputStyle={{
                        textAlign: 'center',
                    }}
                />
                <Header
                    content={'Længde (cm)'}
                    style={{ width: this.state.width[3] }}
                    inputStyle={{ textAlign: 'center' }}
                />
                <Header
                    content={'Dybde'}
                    style={{ width: this.state.width[4] }}
                    inputStyle={{
                        textAlign: 'center',
                    }}
                />
                <Header
                    content={'Område'}
                    style={{ width: this.state.width[5] }}
                    inputStyle={{
                        textAlign: 'center',
                    }}
                />
                <Header
                    content={'Pris'}
                    style={{ width: this.state.width[6] }}
                    inputStyle={{
                        textAlign: 'center',
                    }}
                />
                <Header
                    content={'Sum'}
                    style={{ width: this.state.width[7] }}
                    inputStyle={{
                        textAlign: 'right',
                        paddingRight: 5,
                    }}
                />
            </Row>
        )
    }
    updateFunction = (key, value, index, r) => {
        if (key === 'price' || key === 'amount') { value = value.toString().replace('.', ',') }
        r[key] = value
        this.props.update(r, index)
    }
    parseAndCalcSum(one, two) {
        return (parseFloat(one.toString().replace(',', '.')) * parseFloat(two.toString().replace(',', '.')))
    }
    renderContent = (r, index, tot) => {
        let background = index % 2 == 0 ? semanticColors.mainBackground2 : semanticColors.primaryLight
        let sum = this.parseAndCalcSum(r.price ? r.price : 0, r.amount)
        tot(sum)
        return (
            <Row
                key={index}
            >
                <Cell
                    content={r.pos}
                    onChange={(value) => this.updateFunction('pos', value, index, r)}
                    style={{ width: this.state.width[0] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
                <CellSelect
                    onChange={(value) => this.updateFunction('type', value, index, r)}
                    content={r.type}
                    style={{ width: this.state.width[1] }}
                    inputStyle={{
                        backgroundColor: background
                    }}
                    values={this.getTypeSelectPickerChildren()}
                />
                <Cell
                    onChange={(value) => this.updateFunction('amount', value, index, r)}
                    content={r.amount}
                    style={{ width: this.state.width[2] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
                <Cell
                    onChange={(value) => this.updateFunction('length', value, index, r)}
                    content={r.length}
                    style={{ width: this.state.width[3] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
                <Cell
                    onChange={(value) => this.updateFunction('depth', value, index, r)}
                    content={r.depth}
                    style={{ width: this.state.width[4] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
                <Cell
                    onChange={(value) => this.updateFunction('area', value, index, r)}
                    content={r.area}
                    style={{ width: this.state.width[5] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
                <Cell
                    onChange={(value) => this.updateFunction('price', value, index, r)}
                    content={r.price}
                    style={{ width: this.state.width[6] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
                <Cell
                    readOnly
                    content={(Math.round(sum * 100) / 100).toString().replace('.', ',')}
                    style={{ width: this.state.width[7] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'right',
                        paddingRight: 5,
                    }}
                />
            </Row>
        )
    }
    render() {
        let total = 0
        let rows = this.props.rows.map((r, index) => {
            return this.renderContent(r, index, (e) => { total += e })
        })

        return (
            <div style={[{ width: '100%' }]}>
                {this.renderHeader()}
                {rows}
                <div style={{ float: 'right', padding: 5, borderBottom: '1px solid ' + semanticColors.primaryLight }}>
                    <div style={{ fontWeight: 600 }}>
                        I alt: {(Math.round(total * 100) / 100).toString().replace('.', ',')}
                    </div>
                </div>
            </div>
        )
    }
}

const styles = {
    flexify: {
        display: 'flex',
        flexDirection: 'row',
    },
    column: {
        flexGrow: 0,
        flexShrink: 0,
        verticalAlign: 'top',
    }
}

Measurements.propTypes = propTypes

Measurements.defaultProps = defaultProps

export default Radium(Measurements)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Tilbud/spreadsheets/measurements.js